module.exports = __webpack_public_path__ + "ProsocialTip-c878d90d83d695be14eba2e0a93a42a8.png";